import { useNavigate } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { Add } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const VacanciesRequisitionPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <OneEmptyState
        emoji="📋"
        title={i18n.t('ats.vacancies_requisition_page.empty_state_title')}
        description={i18n.t('ats.vacancies_requisition_page.empty_state_description')}
        actions={[
          {
            label: i18n.t('ats.vacancies_requisition_page.empty_state_button'),
            icon: Add,
            onClick: () => navigate(navigation.ats.hiringPlan.requisitions.new.fullPath()),
          },
        ]}
      />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default VacanciesRequisitionPage
